

const Notice = ({ showNotice, message }) => {
    return showNotice && <>
        <div className='noticeElement'>
            {message}
        </div>
    </>
}
export default Notice;